export default "__VITE_ASSET__BNd387tA__"